import PropTypes from 'prop-types';
import classNames from 'classnames';

import { IconGeneric } from '@spotahome/ui-library';

import './NavigationAngle.scss';

const noop = () => {};

const NavigationAngle = ({ onClick = noop, side = 'left' }) => (
  <div
    className={classNames('navigation-angle', `navigation-angle--${side}`)}
    onClick={onClick}
    role="button"
    tabIndex="0"
  >
    <IconGeneric
      className="navigation-angle__icon"
      size="bigger"
      name={`angle-${side}`}
    />
  </div>
);

NavigationAngle.propTypes = {
  onClick: PropTypes.func,
  side: PropTypes.string
};

export default NavigationAngle;
